export default __webpack_public_path__ + "static/media/IconDesc_SnowballMittens.256.14783f12.png";